class PDPUpsellProduct extends HTMLElement {
  constructor() {
    super();
    this.formId = this.getAttribute("form-id");
    this.checkboxes = this.querySelectorAll("input[type='checkbox']");
    this.init();
  }

  init() {
    this.checkboxes.forEach((checkbox) => {
      checkbox.addEventListener("change", this.handleCheckboxChange.bind(this));

      // Wenn Checkbox bereits gecheckt ist (highlighted), Hidden Input hinzufügen
      if (checkbox.checked) {
        const variantId = checkbox.value;
        const index = checkbox.getAttribute("index");
        const form = document.querySelector(`#${this.formId}`);

        if (form) {
          this.addHiddenInput(form, variantId, index);
        }
      }
    });

    this.initModal();

    // Summary initial aktualisieren, falls bereits Checkboxen gecheckt sind
    const hasCheckedItems = Array.from(this.checkboxes).some(
      (cb) => cb.checked
    );
    if (hasCheckedItems) {
      // Warten bis Summary-Element vollständig initialisiert ist
      requestAnimationFrame(() => {
        const summaryElement = document.querySelector("pdp-upsell-summary");
        if (summaryElement && summaryElement.updateSummary) {
          summaryElement.updateSummary();
        }
      });
    }
  }

  initModal() {
    const variantButtons = this.querySelectorAll(
      "[data-variant-selector-trigger]"
    );
    variantButtons.forEach((button) => {
      button.addEventListener("click", this.openModal.bind(this));
    });

    const modals = document.querySelectorAll(".variant-selector-modal");
    modals.forEach((modal) => {
      const closeButton = modal.querySelector(".variant-selector-modal__close");
      if (closeButton) {
        closeButton.addEventListener("click", () => this.closeModal(modal));
      }

      modal.addEventListener("click", (e) => {
        if (e.target === modal) {
          this.closeModal(modal);
        }
      });

      const optionButtons = modal.querySelectorAll(
        ".variant-selector-modal__option-button, .variant-selector-modal__color-swatch"
      );
      optionButtons.forEach((button) => {
        button.addEventListener("click", (e) =>
          this.handleOptionClick(e, modal)
        );
      });

      const selectButton = modal.querySelector(
        ".variant-selector-modal__select-button"
      );
      if (selectButton) {
        selectButton.addEventListener("click", (e) =>
          this.handleSelectVariant(e, modal)
        );
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        const activeModal = document.querySelector(
          ".variant-selector-modal.active"
        );
        if (activeModal) {
          this.closeModal(activeModal);
        }
      }
    });
  }

  openModal(event) {
    const button = event.currentTarget;
    const productId = button.dataset.productId;
    const currentVariantId = button.dataset.currentVariantId;
    const index = button.dataset.index;

    const modal = document.getElementById(`variantSelectorModal-${productId}`);
    if (!modal) {
      console.error(`Modal not found for product ID: ${productId}`);
      return;
    }

    this.currentSelection = {
      productId,
      currentVariantId,
      index,
      button,
    };

    const currentVariant = this.getVariantData(modal, currentVariantId);
    if (currentVariant) {
      const option1 = currentVariant.dataset.variantOption1;
      const option2 = currentVariant.dataset.variantOption2;

      if (option1) {
        const fabricButton = modal.querySelector(
          `[data-option-position="1"][data-option-value="${option1}"]`
        );
        if (fabricButton) {
          fabricButton.classList.add("selected");
          this.updateSelectedLabel(modal, 0, option1);
        }
      }

      if (option2) {
        const colorButton = modal.querySelector(
          `[data-option-position="2"][data-option-value="${option2}"]`
        );
        if (colorButton) {
          colorButton.classList.add("selected");
          this.updateSelectedLabel(modal, 1, option2);
        }
      }

      const selectedOptions = {};
      if (option1) selectedOptions["1"] = option1;
      if (option2) selectedOptions["2"] = option2;

      this.updateModalVariantDisplay(modal, currentVariant);
      this.updatePrice(
        modal,
        currentVariant.dataset.variantPrice,
        currentVariant.dataset.variantComparePrice
      );
      this.updateAvailability(modal, selectedOptions);

      // Select-Button aktivieren, wenn Variante bereits ausgewählt ist
      const selectButton = modal.querySelector(
        ".variant-selector-modal__select-button"
      );
      if (selectButton && option1 && option2) {
        selectButton.disabled = false;
        selectButton.dataset.selectedVariantId = currentVariantId;
      }
    }

    modal.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  closeModal(modal) {
    modal.classList.remove("active");
    document.body.style.overflow = "";

    const optionButtons = modal.querySelectorAll(
      ".variant-selector-modal__option-button, .variant-selector-modal__color-swatch"
    );
    optionButtons.forEach((btn) => btn.classList.remove("selected"));

    const selectButton = modal.querySelector(
      ".variant-selector-modal__select-button"
    );
    if (selectButton) {
      selectButton.disabled = true;
    }

    this.currentSelection = null;
  }

  handleOptionClick(event, modal) {
    const button = event.currentTarget;
    const position = button.dataset.optionPosition;
    const value = button.dataset.optionValue;

    const siblings = modal.querySelectorAll(
      `[data-option-position="${position}"]`
    );
    siblings.forEach((sibling) => sibling.classList.remove("selected"));

    button.classList.add("selected");
    this.updateSelectedLabel(modal, parseInt(position) - 1, value);

    const selectedOptions = this.getSelectedOptions(modal);
    this.updateAvailability(modal, selectedOptions);

    const matchedVariant = this.findMatchingVariant(modal, selectedOptions);
    if (matchedVariant) {
      this.updateModalVariantDisplay(modal, matchedVariant);
      this.updatePrice(
        modal,
        matchedVariant.dataset.variantPrice,
        matchedVariant.dataset.variantComparePrice
      );

      const selectButton = modal.querySelector(
        ".variant-selector-modal__select-button"
      );
      if (selectButton) {
        selectButton.disabled = false;
        selectButton.dataset.selectedVariantId =
          matchedVariant.dataset.variantId;
      }
    }
  }

  handleSelectVariant(event, modal) {
    const button = event.currentTarget;
    const variantId = button.dataset.selectedVariantId;

    if (!variantId) return;

    const variantData = this.getVariantData(modal, variantId);
    if (!variantData) return;

    this.updateProductDisplay({
      id: variantId,
      title: variantData.dataset.variantTitle,
      price: variantData.dataset.variantPrice,
      compare_at_price: variantData.dataset.variantComparePrice,
      featured_media: {
        src: variantData.dataset.variantImage,
        alt: variantData.dataset.variantImageAlt,
      },
    });

    this.closeModal(modal);
  }

  getSelectedOptions(modal) {
    const selectedOptions = {};
    const selectedButtons = modal.querySelectorAll(".selected");

    selectedButtons.forEach((button) => {
      const position = button.dataset.optionPosition;
      selectedOptions[position] = button.dataset.optionValue;
    });

    return selectedOptions;
  }

  findMatchingVariant(modal, selectedOptions) {
    const variantElements = modal.querySelectorAll("[data-variant-id]");

    for (const variantEl of variantElements) {
      const option1 = variantEl.dataset.variantOption1;
      const option2 = variantEl.dataset.variantOption2;

      const matches =
        (!selectedOptions["1"] || option1 === selectedOptions["1"]) &&
        (!selectedOptions["2"] || option2 === selectedOptions["2"]);

      if (matches && Object.keys(selectedOptions).length === 2) {
        return variantEl;
      }
    }

    return null;
  }

  updateAvailability(modal, selectedOptions) {
    const variantElements = modal.querySelectorAll("[data-variant-id]");
    const availableVariants = Array.from(variantElements).filter(
      (v) => v.dataset.variantAvailable === "true"
    );

    const colorSwatches = modal.querySelectorAll(
      ".variant-selector-modal__color-swatch"
    );

    colorSwatches.forEach((button) => {
      const position = button.dataset.optionPosition;
      const value = button.dataset.optionValue;

      const testOptions = { ...selectedOptions };
      testOptions[position] = value;

      const isAvailable = availableVariants.some((variant) => {
        return (
          (!testOptions["1"] ||
            variant.dataset.variantOption1 === testOptions["1"]) &&
          (!testOptions["2"] ||
            variant.dataset.variantOption2 === testOptions["2"])
        );
      });

      if (isAvailable) {
        button.classList.remove("hidden");
      } else {
        button.classList.add("hidden");
      }
    });
  }

  updateSelectedLabel(modal, position, value) {
    const label = modal.querySelector(`[data-selected-value="${position}"]`);
    if (label) {
      label.textContent = value;
    }
  }

  updateModalVariantDisplay(modal, variantData) {
    const modalImage = modal.querySelector(
      ".variant-selector-modal__product-image img"
    );
    if (modalImage && variantData.dataset.variantImage) {
      modalImage.src = variantData.dataset.variantImage;
      modalImage.alt =
        variantData.dataset.variantImageAlt || variantData.dataset.variantTitle;
    }

    const modalTitle = modal.querySelector(
      ".variant-selector-modal__product-title"
    );
    if (modalTitle) {
      modalTitle.textContent = variantData.dataset.variantTitle;
    }
  }

  updatePrice(modal, price, comparePrice) {
    const priceElement = modal.querySelector("[data-current-price]");
    const comparePriceElement = modal.querySelector("[data-compare-price]");

    if (priceElement) {
      priceElement.textContent = this.formatMoney(price);
    }

    if (comparePriceElement) {
      if (comparePrice && comparePrice !== "null" && comparePrice !== "") {
        comparePriceElement.textContent = this.formatMoney(comparePrice);
        comparePriceElement.style.display = "";
      } else {
        comparePriceElement.textContent = "";
        comparePriceElement.style.display = "none";
      }
    }
  }

  getVariantData(modal, variantId) {
    return modal.querySelector(`[data-variant-id="${variantId}"]`);
  }

  updateProductDisplay(variant) {
    const index = this.currentSelection.index;
    const button = this.currentSelection.button;

    const productItem = button.closest(".product-block--upsell-product-item");
    if (!productItem) return;

    const image = productItem.querySelector(".upsell-product--image img");
    if (image) {
      image.src = variant.featured_media.src;
      image.alt = variant.featured_media.alt || variant.title;
    }

    const variantText = productItem.querySelector(
      ".upsell-product--variant-text"
    );
    if (variantText) {
      variantText.textContent = variant.title;
    }

    const price = productItem.querySelector(".upsell-product--price");
    if (price) {
      price.textContent = this.formatMoney(variant.price);
    }

    const comparePrice = productItem.querySelector(
      ".upsell-product--compare-price"
    );
    if (comparePrice && variant.compare_at_price) {
      comparePrice.textContent = this.formatMoney(variant.compare_at_price);
    }

    productItem.dataset.variantTitle = variant.title;

    const checkbox = productItem.querySelector("input[type='checkbox']");
    if (checkbox) {
      const wasChecked = checkbox.checked;
      checkbox.value = variant.id;
      checkbox.id = `upsell-product-${variant.id}`;

      const label = productItem.querySelector("label");
      if (label) {
        label.setAttribute("for", `upsell-product-${variant.id}`);
      }

      button.dataset.currentVariantId = variant.id;

      // Checkbox aktivieren, wenn Variante im Modal ausgewählt wurde
      if (!wasChecked) {
        checkbox.checked = true;

        const form = document.querySelector(`#${this.formId}`);
        if (form) {
          this.addHiddenInput(form, variant.id, index);
        }
      } else {
        // Wenn bereits gecheckt, Form-Input aktualisieren
        const form = document.querySelector(`#${this.formId}`);
        if (form) {
          this.removeHiddenInput(form, index);
          this.addHiddenInput(form, variant.id, index);
        }
      }

      // Summary aktualisieren
      const summaryElement = document.querySelector("pdp-upsell-summary");
      if (summaryElement && summaryElement.updateSummary) {
        summaryElement.updateSummary();
      }
    }
  }

  formatMoney(cents) {
    const amount = cents / 100;
    const formatted = amount.toFixed(2);
    const [integer, decimal] = formatted.split(".");
    const integerWithSeparator = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return `${integerWithSeparator},${decimal}€`;
  }

  handleCheckboxChange(event) {
    const checkbox = event.target;
    const variantId = checkbox.value;
    const index = checkbox.getAttribute("index");
    const form = document.querySelector(`#${this.formId}`);

    if (!form) {
      console.error(`Form with id "${this.formId}" not found`);
      return;
    }

    if (checkbox.checked) {
      this.addHiddenInput(form, variantId, index);
    } else {
      this.removeHiddenInput(form, index);
    }
  }

  addHiddenInput(form, variantId, index) {
    const existingInput = form.querySelector(
      `input[name="items[${index}][id]"][type="hidden"]`
    );
    if (existingInput) {
      return;
    }

    const hiddenIdInput = document.createElement("input");
    hiddenIdInput.type = "hidden";
    hiddenIdInput.name = `items[${index}][id]`;
    hiddenIdInput.value = variantId;
    hiddenIdInput.setAttribute("data-upsell-index", index);

    const hiddenQuantityInput = document.createElement("input");
    hiddenQuantityInput.type = "hidden";
    hiddenQuantityInput.name = `items[${index}][quantity]`;
    hiddenQuantityInput.value = "1";
    hiddenQuantityInput.setAttribute("data-upsell-index", index);

    form.appendChild(hiddenIdInput);
    form.appendChild(hiddenQuantityInput);
  }

  removeHiddenInput(form, index) {
    const hiddenIdInput = form.querySelector(
      `input[name="items[${index}][id]"][type="hidden"]`
    );
    const hiddenQuantityInput = form.querySelector(
      `input[name="items[${index}][quantity]"][type="hidden"]`
    );

    if (hiddenIdInput) {
      hiddenIdInput.remove();
    }
    if (hiddenQuantityInput) {
      hiddenQuantityInput.remove();
    }
  }
}

if (!customElements.get("pdp-upsell-product")) {
  customElements.define("pdp-upsell-product", PDPUpsellProduct);
}
